// extracted by mini-css-extract-plugin
module.exports = {"info-button":"InfoModal--info-button--2-vn5","infoButton":"InfoModal--info-button--2-vn5"};